import createAxiosInstance from "../utils/axiosInstance";
import Env from "../env/Env";

const request = createAxiosInstance(`${Env.API_BASE}/api/exports`);

export interface ExportJobStatus {
  jobId: string;
  status: 'queued' | 'processing' | 'completed' | 'failed' | 'cancelled';
  progress?: number;
  fileUrl?: string;
  fileName?: string;
  error?: string;
  createdAt: string;
  completedAt?: string;
}

export interface TriggerExportResponse {
  success: boolean;
  jobId: string;
  message: string;
}

const exportAPIsService = {
  getJobStatus: (jobId: string): Promise<ExportJobStatus> => {
    return new Promise((resolve, reject) => {
      request
        .get(`/status/${jobId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.error || 'Failed to get job status');
        });
    });
  },

  cancelJob: (jobId: string): Promise<{ success: boolean; message: string }> => {
    return new Promise((resolve, reject) => {
      request
        .delete(`/cancel/${jobId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.error || 'Failed to cancel job');
        });
    });
  },

  downloadFile: (fileName: string, jobId?: string): Promise<{ signedUrl: string; fileName: string }> => {
    return new Promise((resolve, reject) => {
      const params = jobId ? { jobId } : {};
      request
        .get(`/download/${fileName}`, {
          params,
          timeout: 30000,
        })
        .then((response) => {
          if (response.data.success && response.data.signedUrl) {
            resolve({
              signedUrl: response.data.signedUrl,
              fileName: response.data.fileName || fileName,
            });
          } else {
            reject(new Error(response.data.error || 'Failed to get signed URL'));
          }
        })
        .catch((err) => {
          console.error('Failed to get signed URL:', err);
          reject(err?.response?.data?.error || err?.message || 'Failed to get download URL');
        });
    });
  },

  downloadFileStream: (fileName: string, jobId?: string): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      const params = jobId ? { jobId, stream: 'true' } : { stream: 'true' };
      request
        .get<Blob>(`/download/${fileName}`, {
          responseType: 'blob',
          params,
          timeout: 600000,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          console.error('Stream download error:', err);
          reject(err?.response?.data?.error || err?.message || 'Failed to download file');
        });
    });
  },
};

export default exportAPIsService;

